/**
 * Easily extendable socials list. To add a new social:
 *   1. Add an entry below with the appropriate `kind`.
 *   2. If `kind` is new, add a glyph in nav.tsx + footer.tsx (currently
 *      they handle github / email / rss with fall-through to text-only).
 *
 * The footer renders any kind as a text link by handle, so you can add
 * a brand-new kind (mastodon, bluesky, link, etc.) and it'll just show
 * up ,  you only need to wire the icon if you want one in the nav.
 */
export type Social = {
  kind: "github" | "email" | "rss" | "mastodon" | "bluesky" | "link" | string;
  handle: string; // shown as text
  href: string;   // URL or mailto:
  label?: string; // aria-label override
  external?: boolean;
};

export const socials: Social[] = [
  {
    kind: "github",
    handle: "dablincx",
    href: "https://github.com/dablincx",
    external: true,
  },
  {
    kind: "email",
    handle: "contact@byemily.org",
    href: "mailto:contact@byemily.org",
  },
  {
    kind: "rss",
    handle: "rss",
    href: "/blog/rss.xml",
    label: "RSS feed",
  },
  // Add more here. Uncomment + edit when you sign up:
  // { kind: "mastodon", handle: "@you@instance.tld", href: "https://...", external: true },
  // { kind: "bluesky", handle: "you.bsky.social", href: "https://...", external: true },
  // { kind: "link", handle: "blog", href: "https://...", external: true },
];